import React from 'react'

import clsx from 'clsx'

import { Container } from 'components/Grid'

import HomeHeading from '../HomeHeading'
import HowToUseItem from './components/HowToUseItem'

import icon1SVG from 'assets/how-to-use-icon-1.svg'
import icon2SVG from 'assets/how-to-use-icon-2.svg'
import icon3SVG from 'assets/how-to-use-icon-3.svg'

import classes from './HowToUse.module.scss'

const HOW_TO_USE_DATA = [
  { title: 'Explore software', icon: icon1SVG },
  { title: 'Compare options', icon: icon3SVG },
  { title: 'Find your solution', icon: icon2SVG },
]

const HowToUse = () => {
  return (
    <div className={clsx('HowToUse', classes.root)}>
      <Container className={classes.customContainer}>
        <HomeHeading>How to use GetApp</HomeHeading>
        <div className={classes.items}>
          {HOW_TO_USE_DATA.map(({ title, icon }, i) => (
            <HowToUseItem
              key={`how-to-use-${title}`}
              title={title}
              icon={icon.src}
              index={i}
              isLast={HOW_TO_USE_DATA.length === i + 1}
            />
          ))}
        </div>
      </Container>
    </div>
  )
}

export default HowToUse
